/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/sectors/ProjectList/ProjectList.config.js
 * File: ProjectList.config.js
 * Created Date: Tuesday, January 22nd 2019, 10:31:16 am
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Jan 23 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { FuseLoadable } from 'modules/@fuse'
import { authRoles } from 'modules/auth'

export const ProjectListConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  auth: authRoles.staff,
  routes: [{
    path: '/projects',
    component: FuseLoadable({
      loader: () => import('./ProjectList')
    })
  }]
}
